import script from "./ProjectExportForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectExportForm.vue?vue&type=script&setup=true&lang=js"

import "./ProjectExportForm.vue?vue&type=style&index=0&id=648eb8fe&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-648eb8fe"]])

export default __exports__